// extracted by mini-css-extract-plugin
module.exports = {"DocModalContent":"DocumentDetailModal_DocModalContent__Bi_08","close":"DocumentDetailModal_close__2C4kE"};